export default __webpack_public_path__ + "static/media/salinas.bded2201.jpg";